const menu = {
    icon: 'pi pi-phone',
    label: 'Chamados',
    to: '/sol/atendimentoChamado',
    rules: ['SOL-001'],
};

export default menu;
